export const removeFile = (fileList: File[], file: File): File[] => {
    const fileIndex = fileList.indexOf(file);
    fileIndex !== -1 && fileList.splice(fileList.indexOf(file), 1);
    return fileList;
};
